import isString from '@commons/utils/string/isString';

function toLowerCase(data) {
  return isString(data) ? data.toLowerCase() : '';
}

export default toLowerCase;
